import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getGlobalScope, getCurrentScope, addBreadcrumb, getClient, addNonEnumerableProperty } from '@sentry/core';
var ACTION_BREADCRUMB_CATEGORY = 'redux.action';
var ACTION_BREADCRUMB_TYPE = 'info';
var defaultOptions = {
  attachReduxState: true,
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  stateTransformer: function stateTransformer(state) {
    return state || null;
  }
};

/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */
function createReduxEnhancer(enhancerOptions) {
  // Note: We return an any type as to not have type conflicts.
  var options = _objectSpread(_objectSpread({}, defaultOptions), enhancerOptions);
  return function (next) {
    return function (reducer, initialState) {
      options.attachReduxState && getGlobalScope().addEventProcessor(function (event, hint) {
        try {
          // @ts-expect-error try catch to reduce bundle size
          if (event.type === undefined && event.contexts.state.state.type === 'redux') {
            hint.attachments = [].concat(_toConsumableArray(hint.attachments || []), [
            // @ts-expect-error try catch to reduce bundle size
            {
              filename: 'redux_state.json',
              data: JSON.stringify(event.contexts.state.state.value)
            }]);
          }
        } catch (_) {
          // empty
        }
        return event;
      });
      var sentryReducer = function sentryReducer(state, action) {
        var newState = reducer(state, action);
        var scope = getCurrentScope();

        /* Action breadcrumbs */
        var transformedAction = options.actionTransformer(action);
        if (typeof transformedAction !== 'undefined' && transformedAction !== null) {
          addBreadcrumb({
            category: ACTION_BREADCRUMB_CATEGORY,
            data: transformedAction,
            type: ACTION_BREADCRUMB_TYPE
          });
        }

        /* Set latest state to scope */
        var transformedState = options.stateTransformer(newState);
        if (typeof transformedState !== 'undefined' && transformedState !== null) {
          var client = getClient();
          var _options = client && client.getOptions();
          var normalizationDepth = _options && _options.normalizeDepth || 3; // default state normalization depth to 3

          // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
          var newStateContext = {
            state: {
              type: 'redux',
              value: transformedState
            }
          };
          addNonEnumerableProperty(newStateContext, '__sentry_override_normalization_depth__', 3 +
          // 3 layers for `state.value.transformedState`
          normalizationDepth // rest for the actual state
          );

          scope.setContext('state', newStateContext);
        } else {
          scope.setContext('state', null);
        }

        /* Allow user to configure scope with latest state */
        var configureScopeWithState = options.configureScopeWithState;
        if (typeof configureScopeWithState === 'function') {
          configureScopeWithState(scope, newState);
        }
        return newState;
      };
      return next(sentryReducer, initialState);
    };
  };
}
export { createReduxEnhancer };